import * as React from 'react';
import { useDispatch, useSelector } from '@grandvisionhq/state';
import { TitleWithIcon } from '../../../components/TitleWithIcon/TitleWithIcon.js';
import { CheckoutForm } from '../../../components/Forms/CheckoutForm.js';
import { FormFieldsWithCart } from '../../../components/FormFieldsWithCart/FormFieldsWithCart.js';
import { useIsFormSlotAvailable } from '../../../slots/forms/form-context.js';
import '../../../slots/summaries/summary-context.js';
import '../../../slots/summaries/types.js';
import { ShippingObjectTypes } from '../../../state.js';
import { updateShippingDetails } from '../../actions.js';
import { getDeliveryAddressFormData } from '../../selectors.js';
import { HighlightedForm } from '../HighlightedForm.js';

const DeliveryForm = ({ deliveryAddressLabel  })=>{
    const isDeliveryFormAvailable = useIsFormSlotAvailable(ShippingObjectTypes.DeliveryAddress);
    const dispatch = useDispatch();
    const handleChange = React.useCallback((formData)=>{
        dispatch(updateShippingDetails({
            form: formData
        }));
    }, [
        dispatch
    ]);
    const deliveryAddressInitialData = useSelector(getDeliveryAddressFormData);
    if (!isDeliveryFormAvailable) return null;
    return /*#__PURE__*/ React.createElement(HighlightedForm, {
        key: "delivery-highlight",
        className: "checkout-step__highlight"
    }, /*#__PURE__*/ React.createElement(TitleWithIcon, {
        icon: "location-pin",
        label: deliveryAddressLabel
    }), /*#__PURE__*/ React.createElement(CheckoutForm, {
        formName: "deliveryAddress",
        "data-t": "deliveryAddress",
        initialFormState: deliveryAddressInitialData,
        onChange: handleChange
    }, /*#__PURE__*/ React.createElement(FormFieldsWithCart, {
        formName: ShippingObjectTypes.DeliveryAddress
    })));
};

export { DeliveryForm };
//# sourceMappingURL=DeliveryForm.js.map
